import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoadingService } from "@coso/loading";
import { IS_SAAS, RuntimeSettingsService } from "@coso/utility";
import { BehaviorSubject, map } from "rxjs";
import { ReplicatorUiSettings } from "../../../../../../../../apps/saas/src/app/models/replicator-ui-settings";
import { IServiceStatus, ISharePointStructureCreatorLicenseInfo, ServiceStatusEnum } from "../../../../models/auto-generated";
import { LicenseService } from "../../../../services/license.service";
import { handleError } from "../../../../utils/handle-error";
import { SharePointStructureCreatorService } from "../../services/sharepoint-structure-creator.service";


@Component({
  standalone:false,
  templateUrl: "./board.component.html",
  styleUrls: ["./board.component.scss"],
})
export class BoardComponent implements OnInit {  
  ServiceStatusEnum = ServiceStatusEnum;
  instanceId: string;  
  errorMessage: string;
  license: ISharePointStructureCreatorLicenseInfo;  
  token: string;
  uiAppSettings: ReplicatorUiSettings;

  isReadOnly = new BehaviorSubject<boolean>(false);
  get isReadOnly$() {
    return this.isReadOnly.asObservable();
  }

  status = new BehaviorSubject<IServiceStatus>(undefined);
  get status$() {    
    return this.status.pipe(map(s => s?.status));
  }

  constructor(
    @Inject(IS_SAAS) public isSaaS: boolean,    
    public loadingService: LoadingService,
    private route: ActivatedRoute,
    configSvc: RuntimeSettingsService,
    private licenseService: LicenseService,
    private structureCreatorService: SharePointStructureCreatorService
  ) {
    this.uiAppSettings = configSvc.configObject as ReplicatorUiSettings;
  }

  ngOnInit() {
    this.instanceId = this.route.parent.snapshot.paramMap.get("instance-id");
    this.loadStatusAndLicenseInfo(); 
  }

  deactivate() {
    this.loadingService.start("Disabling configuration at Dynamics 365", "deactivate");
    this.structureCreatorService.deactivate(this.instanceId).subscribe(
      (result) => {
        this.status.next(result);
        this.loadingService.stop("deactivate");
      },
      (error) => {
        this.errorMessage = `Something went wrong due to: ${handleError(error)}`;
        this.loadingService.stop("deactivate");
      }
    );
  }

  activate() {
    this.loadingService.start("Enabling configuration at Dynamics 365", "activate");
    this.structureCreatorService.activate(this.instanceId).subscribe(
      (result) => {
        this.status.next(result);
        this.loadingService.stop("activate");
      },
      (error) => {
        this.errorMessage = `Something went wrong due to: ${handleError(error)}`;
        this.loadingService.stop("activate");
      }
    );
  }

  private loadStatusAndLicenseInfo() {
    this.loadingService.start("Loading board information", "loadBoardInfo");
    this.licenseService.getSscLicenseInfo(this.instanceId).subscribe({
      next: (licenseInfo) => {
        this.license = licenseInfo;
        this.loadingService.stop("loadBoardInfo");
      },
      error : (error) => {
        this.errorMessage = `Something went wrong due to: ${handleError(error)}`;
        this.loadingService.stop("loadBoardInfo");
      }
    });
  }
}
